(function () {
  const container = document.getElementById('ZoomyWishlistPage');
  if (!container) return;

  const EMPTY_TEXT = 'Please add products in your wishlist to see them here.';
  function ensureEmptyState() {
    if (!container.classList.contains('zooomywishlistgridclass')) return;
    const cards = container.querySelectorAll('.ZoomyWishlistPageGrid').length;
    const fallback = container.querySelector('[data-wishlist-empty-fallback]');
    const appMsg = [].some.call(
      container.querySelectorAll('.zwishemptymsg, .zmsg'),
      function (el) { return !fallback || !fallback.contains(el); }
    );

    if (cards > 0 || appMsg) {
      if (fallback) fallback.remove();
      return;
    }
    
    if (!fallback) {
      const wrap = document.createElement('div');
      wrap.className = 'zwishemptymsg';
      wrap.setAttribute('data-wishlist-empty-fallback', '');

      const msg = document.createElement('p');
      msg.className = 'zmsg';
      msg.textContent = EMPTY_TEXT;

      wrap.appendChild(msg);
      container.appendChild(wrap);
    }
  }

  
  function fixProductLinks() {
    const links = container.querySelectorAll('a[target="_blank"]');
    links.forEach(function (a) {
      const href = a.getAttribute('href') || '';
      if (href.indexOf('/products/') !== -1) {
        a.removeAttribute('target');
      }
    });
  }

  function update() {
    ensureEmptyState();
    fixProductLinks();
  }

  update();

  const observer = new MutationObserver(update);
  observer.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
